import * as S from "./loginTemplates.styles";

interface LoginProps {
  children?: React.ReactNode;
}

export const LoginTemplate = ({ children }: LoginProps) => {
  return (
    <S.LoginTemplate>
      <S.LoginBox>{children}</S.LoginBox>
    </S.LoginTemplate>
  );
};
